<footer>
  <app-nav-links></app-nav-links>
</footer>
